import { numberWithoutComma } from "../../pages/balance/component/VIDrawerDebt.Main";

export const SumSaving = (addExpensesInvest) => {
  let sumAllSavain = 0;
  
  addExpensesInvest?.map((row, index) => {
    /*---- เงินลงทุน ----*/
    if (row.options_expenses_invest === "expenses_invest") {
      sumAllSavain += numberWithoutComma(row?.pay_permonth || 0) * 12;
    }

    /*---- เงินออมวัยเกษียณ ----*/
    if (row?.options_expenses_invest === "expenses_conservation") {
      sumAllSavain += numberWithoutComma(row?.pay_permonth || 0) * 12;
    }

    /*---- เงินออมกองทุน RMF ----*/
    if (row?.options_expenses_invest === "expenses_rmf") {
      sumAllSavain += numberWithoutComma(row?.pay_permonth || 0) * 12;
    }

    /*---- อื่น ๆ ----*/
    if (row?.options_expenses_invest === "expenses_other") {
        sumAllSavain += numberWithoutComma(row?.pay_permonth || 0) * 12;
      }
  });
  return sumAllSavain;
};
